import { AppIntegrationsRepository, ActivationCodesRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

/**
 * Subscription activation confirmation controller
 * Handles activation status (unused -> used).
 */

angular.module('controllers')
    .controller(
        'ActivationConfirmation',
        (
            $scope, $window, $stateParams, Util,
            ActivationCodeRestService,
            LicenseRestService,
        ) => {

            const activationCodeId = $stateParams.resourceId;
            const activationCode = ActivationCodesRepository.getById(activationCodeId);

            const fetchActivationCodeOf = (license) => {

                const activationCodeNr = Util.deepFind(license, 'relationships.activation-code.data.id');

                if (activationCodeNr) {

                    ActivationCodeRestService
                        .getById(activationCodeNr)
                        .then((response) => {

                            const responseData = Util.deepFind(response, 'data.data');
                            ActivationCodesRepository.addOrUpdate(responseData);

                        })
                        .then(null, () => {

                            Alert.error('cw.general.ui.error');

                        });

                }

            };

            $scope.appIntegration =
                AppIntegrationsRepository.getById(activationCode.relationships.app.data.id);

            $scope.cancel = () => {

                Util.closeModal();

            };

            $scope.confirm = () => {

                const licensePayload = {
                    data: {
                        type: 'licenses',
                        relationships: {
                            'activation-code': {
                                data: { type: 'activation-codes', id: activationCodeId },
                            },
                            provider: {
                                data: { type: 'providers', id: $window.appName },
                            },
                        },
                    },
                };

                Mixpanel.send('ConnectWeb Activate Click', {
                    Page: 'Subscriptions',
                    Product: $scope.appIntegration.attributes.resource.oeName,
                    'Product ID': activationCode.relationships.app.data.id,
                });

                LicenseRestService
                    .create(licensePayload)
                    .then((response) => {

                        Util.closeModal();
                        fetchActivationCodeOf(Util.deepFind(response, 'data.data'));

                    })
                    .then(null, (error) => {

                        const errorCode =
                            (
                                error.data.errors &&
                                error.data.errors[0]
                            ) ? error.data.errors[0].code : false;

                        Util.closeModal();

                        switch (errorCode) {

                        case '21224': // activation code was not found

                            Alert.error('cw.subscription.error.status_code_not_found');
                            break;

                        case '21223': // activation code invalid

                            Alert.error('cw.subscription.error.status_code_invalid');
                            break;

                        case '21236': // activation code already used

                            Alert.error('cw.subscription.error.status_code_already_used');
                            break;

                        case '21225': // activation code expired

                            Alert.error('cw.subscription.error.status_code_expired');
                            break;

                        case '21241': // maximum users for activation code

                            Alert.error('cw.subscription.error.max_users_reached');
                            break;

                        default:

                            Alert.error('cw.notification.system.error');

                        }

                    });

            };

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/activation-confirmation.js